import { snakeCase } from 'lodash';

interface OwnerMotivationData {
  payrollHowYouPayToday?: string;
  payrollSoftwareName?: string;
  businessAge?: string;
  expectedLaunchDate?: string;
  [key: string]: string | boolean | null | undefined;
}

export const titleCase = (string: string) =>
  string
    ?.split(' ')
    .map(
      item =>
        item.substring(0, 1).toUpperCase() + item.substring(1).toLowerCase()
    )
    .join(' ');

export const formatUseTypes = (
  data: OwnerMotivationData,
  isProductGrowthHiringTileSignupEnabled: boolean
) => {
  const {
    payrollHowYouPayToday,
    payrollSoftwareName,
    businessAge,
    expectedLaunchDate,
    ...restMotivation
  } = data;

  const filteredKeys = Object.keys(restMotivation).filter((key: string) => {
    // Include hiring only if the feature flag is enabled
    if (key === 'hiring' && !isProductGrowthHiringTileSignupEnabled) {
      return false;
    }
    return restMotivation[key];
  });

  const useType = filteredKeys.map((key: string) => snakeCase(key)).join(', ');

  return useType;
};
